import { getControlItem, seekCurrentTime } from '../utils/helpers'
import { BUTTON_ICON_CLASS, CONTROL_CLASS } from '../utils/videoplayer-constants'
import { Controls } from './controls'

export class SeekButtons extends Controls {
  constructor(element: HTMLElement, videoPlayer: HTMLVideoElement, wrapperElement: HTMLDivElement) {
    super(element, videoPlayer, wrapperElement)
    this.renderBackSeekButton()
    this.renderForwardSeekButton()
  }

  private renderBackSeekButton() {
    this.controlBarSectionElement.appendChild(
      getControlItem({
        parent: {
          element: 'button',
          classes: [CONTROL_CLASS, 'cmp-video-wrapper__controls--back-seek'],
        },
        children: [
          {
            element: 'span',
            classes: [BUTTON_ICON_CLASS, 'cmp-button__icon--seek-back'],
          },
        ],
        eventListeners: ['click'],
        callback: () => {
          seekCurrentTime(this.videoPlayer, 5, false)
        },
      }),
    )
  }

  private renderForwardSeekButton() {
    this.controlBarSectionElement.appendChild(
      getControlItem({
        parent: {
          element: 'button',
          classes: [CONTROL_CLASS, 'cmp-video-wrapper__controls--forw-seek'],
        },
        children: [
          {
            element: 'span',
            classes: [BUTTON_ICON_CLASS, 'cmp-button__icon--seek-forw'],
          },
        ],
        eventListeners: ['click'],
        callback: () => seekCurrentTime(this.videoPlayer, 5),
      }),
    )
  }
}
